import { BCMSStateManagerCRUD } from "bcms-react";
import LoginPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/LoginPage";
import "./styles.css";

export default function CaptureFastBalancesLogin(props) {
    // initalize a new BCMSStateManagerCRUD instance using the default page data
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
    .update([ "userID" ], "geo****")
    .update([ "saveUserIDToggleOn" ], true)
    .submit();

    return <div className="login-001"><LoginPage data={ data } /></div>
}
